import { useSelector } from "react-redux";
import SlideUpAnimation from "../SlideUpAnimation/SlideUpAnimation";
import { getLang } from "../../features/app/appSlice";
import { NavLink } from "react-router-dom";
import { conference0, logoStep } from "../../assets/assetsExport";

export default function NewsHighlightSection() {
  const lang = useSelector(getLang);
  return (
    <div className="border-t border-black pt-6 my-32">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-10">
        <h2 className="font-header text-3xl leading-normal">
          {lang ? "Latest News" : "最新动态"}
        </h2>
        <p className="text-sm text-secondary-dark/60 tracking-widest uppercase">
          {lang ? "News & Insights" : "新闻与洞察"}
        </p>
      </div>
      <SlideUpAnimation>
        <NavLink
          to="/news/step-alpine-conference-2026"
          className="group block bg-secondary-dark text-white overflow-hidden"
          aria-label={
            lang
              ? "Read: The New Vision Family Office Team Invited to Attend the STEP Alpine Conference 2026 in Switzerland"
              : "阅读：新愿景家族办公室团队受邀出席 2026 年瑞士 STEP 阿尔卑斯峰会"
          }
        >
          <div className="flex flex-col sm:flex-row">
            <div className="relative w-full sm:w-1/2 h-[300px] sm:h-auto sm:min-h-[420px] overflow-hidden">
              <img
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                src={conference0}
                alt={
                  lang
                    ? "STEP Alpine Conference 2026 in Interlaken, Switzerland"
                    : "2026 年瑞士因特拉肯 STEP 阿尔卑斯峰会"
                }
              />
              <div className="absolute inset-0 bg-gradient-to-t from-secondary-dark/80 via-secondary-dark/30 to-transparent sm:bg-gradient-to-r sm:from-transparent sm:via-transparent sm:to-secondary-dark/40"></div>
              <div className="absolute top-6 left-6 flex items-center gap-3">
                <span className="bg-white text-secondary-dark text-[10px] tracking-[0.2em] uppercase px-3 py-1 font-medium">
                  {lang ? "News" : "新闻"}
                </span>
                <span className="text-white/80 text-[10px] tracking-widest uppercase">
                  May 2026 · Interlaken
                </span>
              </div>
            </div>
            <div className="w-full sm:w-1/2 p-8 sm:p-10 flex flex-col justify-between gap-6">
              <div>
                <p className="font-medium pb-4 text-main">
                  {lang ? "FEATURED" : "特别报道"}
                </p>
                <p className="font-header text-2xl sm:text-3xl leading-snug">
                  {lang
                    ? "New Vision Family Office Invited to the STEP Alpine Conference 2026 in Switzerland"
                    : "新愿景家族办公室受邀出席 2026 年瑞士 STEP 阿尔卑斯峰会"}
                </p>
                <p className="py-4 text-sm text-white/80 leading-relaxed">
                  {lang
                    ? "On 6–7 May, the team joined leading professionals from nearly 50 countries at the Congress Kursaal Interlaken to discuss the future of trusts, family offices and cross-border wealth succession."
                    : "5 月 6 日至 7 日，团队与来自近 50 个国家和地区的行业专业人士齐聚因特拉肯库尔萨尔会议中心，共同探讨信托、家族办公室与跨境财富传承的发展趋势。"}
                </p>
              </div>
              <div className="flex items-center justify-between gap-4">
                <span className="bg-white text-secondary-dark px-3 py-1 font-medium text-sm group-hover:bg-main group-hover:text-white transition-colors">
                  {lang ? "READ MORE" : "阅读更多"}
                </span>
                <img
                  src={logoStep}
                  alt="STEP"
                  className="h-7 object-contain opacity-80 invert"
                />
              </div>
            </div>
          </div>
        </NavLink>
      </SlideUpAnimation>
    </div>
  );
}
